import { useEffect, useRef, useState } from '@max/max';
import { LIST_STATUS, LOAD_MORE_STATUS } from '../components/list-container/types';
import { useRequest } from './useRequest';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
export var RequestType;
(function (RequestType) {
    RequestType["INIT"] = "init";
    RequestType["LOAD_MORE"] = "loadMore";
})(RequestType || (RequestType = {}));
export function useRequestList() {
    const { data, setData, request, isLoading, isSuccess, isError } = useRequest();
    const requestTypeRef = useRef(RequestType.INIT);
    const ctx = useMonitorEngineContext();
    useEffect(() => {
        if (isSuccess) {
            requestTypeRef.current === RequestType.INIT ? setListStatus(LIST_STATUS.SUCCESS) : setLoadMoreStatus(LOAD_MORE_STATUS.SUCCESS);
        }
        if (isError) {
            requestTypeRef.current === RequestType.INIT ? setListStatus(LIST_STATUS.ERROR) : setLoadMoreStatus(LOAD_MORE_STATUS.ERROR);
        }
        if (isLoading) {
            requestTypeRef.current === RequestType.INIT ? setListStatus(LIST_STATUS.LOADING) : setLoadMoreStatus(LOAD_MORE_STATUS.LOADING);
        }
    }, [isSuccess, isError, isLoading, data]);
    const [listStatus, setListStatus] = useState(LIST_STATUS.LOADING);
    const [loadMoreStatus, setLoadMoreStatus] = useState(LOAD_MORE_STATUS.SUCCESS);
    const [isLastPage, setIsLastPage] = useState(false);
    const requestList = async (options, requestType) => {
        requestTypeRef.current = requestType;
        const { onSuccess } = options;
        const onSuccessProxy = (res) => {
            if (res?.list?.length > 0) {
                ctx._raptorReport.monitorReportShelfNormal({
                    cityId: options.requestConfig.params.cityId.toString()
                });
            }
            else {
                ctx._raptorReport.monitorReportShelfEmpty({
                    cityId: options.requestConfig.params.cityId.toString()
                });
            }
            if (res?.isEnd) {
                setIsLastPage(true);
            }
            if (onSuccess) {
                onSuccess(res);
            }
            if (requestTypeRef.current === RequestType.LOAD_MORE && data?.list) {
                const newList = [...data.list, ...res.list];
                setData({
                    ...res,
                    list: newList
                });
            }
        };
        options.onSuccess = onSuccessProxy;
        request(options);
    };
    return {
        data,
        listStatus,
        loadMoreStatus,
        isLastPage,
        requestList
    };
}
